import type { SVGProps } from 'react'
import * as React from 'react'

const kButtonIcon = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x={0.8} y={0.8} width={20.4} height={20.4} rx={5.2} stroke="#1B1C1F" strokeOpacity={0.1} strokeWidth={1.6} />
    <path
      d="M8.06689 15V7H9.51611V10.6758H9.61377L12.7349 7H14.5044L11.4106 10.5898L14.5317 15H12.7896L10.4028 11.5703L9.51611 12.6172V15H8.06689Z"
      fill="#78787A"
    />
  </svg>
)
export default kButtonIcon
